import { publicConfig } from 'config'
import PlaywireRampScript from 'shared-components/ad/PlaywireRampScript'
import AdBlockerScript from 'shared-components/ad/AdBlockerScript'
import AffilimateScript from 'shared-components/thirdparty/AffilimateScript'
import FunnelScript from 'shared-components/thirdparty/FunnelScript'
import GTM from 'shared-components/thirdparty/GTM'
import GtmGtag from 'shared-components/thirdparty/GtmGtag'
import OneSignalScript from 'shared-components/thirdparty/OnesignalScript'
import HotjarScript from 'shared-components/thirdparty/HotjarScript'
import OptimizeScript from 'shared-components/thirdparty/OptimizeScript'

const Thirdparty: React.VFC = () => {
  const optimizeId = publicConfig('googleOptimizeId')

  const funnelId = publicConfig('funnelCustomerId')

  const onesignalId = publicConfig('oneSignalAppId')
  const onesignalDelay = publicConfig('onesignalLoadDelay')
  const onesignalLimit = publicConfig('oneSignalTagLimit')

  const adsDisabled = publicConfig('adsDisabled')
  const playwirePublisher = publicConfig('playwirePublisher')
  const playwireWebsite = publicConfig('playwireWebsite')

  const adBlockScript = publicConfig('adBlockerScript')

  const gtmId = publicConfig('gtmDesktopId')

  const hotjarConfig = publicConfig('hotjarConfig')

  const affilimateToken = publicConfig('affilimateToken')
  const gtagId = publicConfig('gtmGtagId')

  return (
    <>
      {affilimateToken ? <AffilimateScript token={affilimateToken} /> : null}
      {gtmId ? <GTM gtmId={gtmId} /> : null}

      {!adsDisabled && playwirePublisher && playwireWebsite ? (
        <PlaywireRampScript publisherId={playwirePublisher} websiteId={playwireWebsite} />
      ) : null}

      {optimizeId ? <OptimizeScript optimizeId={optimizeId} /> : null}

      {funnelId ? <FunnelScript customerId={funnelId} /> : null}
      {onesignalId ? (
        <OneSignalScript appId={onesignalId} loadDelay={onesignalDelay} tagLimit={onesignalLimit} />
      ) : null}
      <AdBlockerScript blockScript={adBlockScript} />
      {gtagId ? <GtmGtag id={gtagId} /> : null}
      {hotjarConfig ? <HotjarScript hotjarConfig={hotjarConfig} /> : null}
    </>
  )
}

export default Thirdparty
